export default {
    getCountryDynamic(state){
        let country = []
        state.country.map((item)=>{
          country.push({label:item.name,value:item.numeric})
        })
        return country
    },
    getProvinceDynamic(state){
        let province = []
        state.province.map((item,index)=>{
            province.push({label:item,value:index+1})
        })
        return province
    },
};
